import { createAction, props } from "@ngrx/store";
import { GetTransactionDashboardTotalCountAmountOutputDto } from "@shared/service-proxies/service-proxies";

export const setTransactionsStat = createAction('[Dashboard Transaction] Set Transactions List', props<{transactions: any[], isYesterday: boolean, isLastMonth: boolean}>());